import React from 'react';
import { RouteFormatter } from '../routes';

export const spotUrl = (spotUrl) => RouteFormatter.listings({ first: spotUrl });
export const SpotEle = ({ spot = {} }) => (
    <a href={spotUrl(spot?.spotUrl)} target="_blank" rel="noreferrer">
        {spot?.title}
    </a>
);
export const FullFencedSearch = ({ city }) => (
    <a
        href={RouteFormatter.fencedListings(null, {
            query: {
                loc: `${city.name}, ${city.stateShort.toUpperCase() || city.stateUrl}`,
                lat: city.latitude || undefined,
                lng: city.longitude || undefined,
            },
        })}
        target="_blank"
        rel="noreferrer nofollow"
    >
        fully enclosed options
    </a>
);

export const seoFaqs = (city) => {
    const {
        name,
        reviews,
        swimmingSpot,
        trailSpot,
        trailSpotsCount,
        agilitySpot,
        agilitySpotsCount,
        beachSpot,
        dogPresentsCount,
        fieldSpot,
        fieldSpotsCount,
        fiveStarsPercentage,
        fullyFencedCount,
    } = city;

    return [
        {
            show: true,
            que: 'Are dog parks good for dogs?',
            ans: () => (
                <>
                    It is important for dogs to have off leash exercise to sniff and run. But the free and open nature of public dog parks has
                    drawbacks. There could be aggressive dogs, disease transmission and cleanliness issues. For this reason, many dog behaviorists
                    discourage visiting public dog parks and recommend Sniffspot's private dog parks. Sniffspot private dog parks only allow one guest
                    to book at a time and are not open to the public, which solves many of these issues.
                </>
            ),
        },
        {
            show: true,
            que: 'Are dog parks safe?',
            ans: () => (
                <>
                    While public dog parks have a number of safety issues, such as aggressive dogs, disease transmission and general cleanliness,
                    Sniffspot dog parks much safer than public dog parks. With Sniffspot all bookings are private for just you and dogs you bring with
                    you and we require all dogs to be vaccinated (or have equivalent titers). All Sniffspot locations are vetted and reviewed by
                    guests so you can find the perfect place for you and your dog.
                    {reviews.length ? ` ${fiveStarsPercentage}% of reviews on Sniffspot visits in the ${name} area are 5 stars.` : ''}
                </>
            ),
        },
        {
            show: true,
            que: 'How do I know if a dog park works for my dog?',
            ans: () => (
                <>
                    You can filter Sniffspot dog parks by fencing and distractions. If your dog doesn't have good recall, you can visit one of our{' '}
                    {fullyFencedCount > 0 ? `${fullyFencedCount} ` : ''}fully fenced dog parks in the area. If your dog is reactive to other dogs, you
                    can visit one of our {dogPresentsCount > 0 ? `${dogPresentsCount} ` : ''}off leash areas where there are no dogs audible or
                    visible nearby. You can also filter locations to avoid other domestic animals and people. We also recommend reading reviews and
                    reaching out to the host with any questions.
                </>
            ),
        },
        {
            show: !!beachSpot,
            que: `What is the best dog beach near ${name}?`,
            ans: () => (
                <>
                    The best Sniffspot dog beach near {name} is <SpotEle spot={beachSpot} />. At Sniffspot beaches dogs can generally be off leash.
                </>
            ),
        },
        {
            show: fullyFencedCount > 1,
            que: `Does ${name} have any fully fenced dog parks?`,
            ans: () => (
                <>
                    Sniffspot has {fullyFencedCount} fully fenced dog parks in or near {name}. Browse all <FullFencedSearch city={city} />.
                </>
            ),
        },
        {
            show: trailSpotsCount >= 2,
            que: `Where are good dog hiking trails near ${name}?`,
            ans: () => (
                <>
                    The {name} area has {trailSpotsCount} Sniffspot locations with private trails for you and your dog to walk or hike. Dogs can
                    generally be off leash on Sniffspot trails. The most popular trail is <SpotEle spot={trailSpot} />.
                </>
            ),
        },
        {
            show: agilitySpotsCount >= 2,
            que: `Are there dog agility courses for rent in ${name}?`,
            ans: () => (
                <>
                    Sniffspot has dog parks with agility equipment and/or dog obstacles in or near {name}. The most popular agility option is{' '}
                    <SpotEle spot={agilitySpot} />.
                </>
            ),
        },
        {
            show: !!swimmingSpot,
            que: `Where in ${name} can I find a pool for dog swimming?`,
            ans: () => (
                <>
                    Sniffspot has swimming options in the {name} area. The highest rated option is <SpotEle spot={swimmingSpot} />.
                </>
            ),
        },
        {
            show: fieldSpotsCount >= 2,
            que: `Can I rent a field for my dog to run near ${name}?`,
            ans: () => (
                <>
                    There are {fieldSpotsCount} Sniffspot dog parks that offer fields in or near {name} where dogs can be off leash. The most popular
                    field is <SpotEle spot={fieldSpot} />.
                </>
            ),
        },
    ];
};
